/* @flow */

import React from 'react';
import {useSelector} from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

type BuyerInvoiceBoughtAutomaticallyFilterComponentProps = {
  disabled: boolean;
  fullWidth: boolean;
  margin: string;
  value: string;
  changeHandler: (statusKey: string) => void;
}

const useStyles = makeStyles({
  inputRoot: {
    "& .MuiIconButton-label": {
      color: '#3cf',
    }
  },
});

export default function BuyerInvoiceBoughtAutomaticallyFilterComponent(props: BuyerInvoiceBoughtAutomaticallyFilterComponentProps) {
  const translations = useSelector(state => state.locale.translations.filter(t => t.key.startsWith('general.label')));

  const options = [];
  const yesId = 'yes';
  const yesLabel = translations.find(t => t.key === `general.label.yes`)?.text;
  const noId = 'no';
  const noLabel = translations.find(t => t.key === `general.label.no`)?.text;
  options.push({id: yesId, label: yesLabel});
  options.push({id: noId, label: noLabel});

  const value = options.find(o => o.id === props.value);
  
  const classes = useStyles();

  const handleSelect = (value: string) => {
    if (value == null) return props.changeHandler('');
    return props.changeHandler(value);
  }; 

  return (
    <Autocomplete
      disabled={props.disabled}
      getOptionLabel={(value) => value.label}
      onChange={(_, newValue) => handleSelect(newValue?.id || null)}
      openOnFocus
      options={options}
      classes={classes}
      renderInput={(params) =>
        <TextField 
          {...params}
          fullWidth={props.fullWidth}
          margin={props.margin}
        />
      }
      value={value}
    />
  );
}
